import { TagState } from './Tag.type';
import { createSlice } from '@reduxjs/toolkit';
import { getTagListThunk } from './Tag.thunk';
import { RootState } from '../store';

const initialState: TagState = {
  items: [],
  isLoading: false,
  pagination: {} as any,
};

export const tagSlice = createSlice<TagState, any>({
  name: 'tag',
  initialState,
  reducers: {} as any,
  extraReducers: builder => {
    builder.addCase(getTagListThunk.pending, state => {
      state.isLoading = true
    });
    builder.addCase(getTagListThunk.fulfilled, (state, { payload }) => {
      const { data, pagination } = payload;
      state.isLoading = false;
      state.items = data;
      state.pagination = {
        currentPage: pagination.current_page,
        lastPage: pagination.last_page,
        perPage: pagination.per_page,
        from: pagination.from,
        to: pagination.to,
        total: pagination.total,
      };
    });
    builder.addCase(getTagListThunk.rejected, state => {
      state.isLoading = false;
    })
  }
});

export const getTagList = (state: RootState) => state.tag.items;

export default tagSlice.reducer

